<script>
	// Componentes Svelte
	import { Router, Link, link , Route }   from "svelte-routing";
	import { 
		linkAV, 
		textTelefone, 
		linkTelefone,
		textWhatsappVendas, 
		linkWhatsappVendas,
		textWhatsappLocacao, 
		linkWhatsappLocacao,
	} from './store.js';

	// Componentes
	import Header 				from "./components/Header.svelte";
	import Footer 				from "./components/Footer.svelte";
	import Aviso 				from "./components/Aviso.svelte";

	// Rotas/Pages
	import Home 					from "./routes/Home.svelte";
	import Imoveis 					from "./routes/Imoveis.svelte";
	import Anuncie 					from "./routes/Anuncie.svelte";
	import Imovel 					from "./routes/Imovel.svelte";
	import SoliciteImovel 			from "./routes/SoliciteImovel.svelte";
	import Sobre 					from "./routes/Sobre.svelte";
	import Privacidade				from "./routes/Privacidade.svelte";
	import Contato 					from "./routes/Contato.svelte";
	import Favoritos 				from "./routes/Favoritos.svelte";
	import FavoritosImobiliaria 	from "./routes/FavoritosImobiliaria.svelte";
	import FavoritosAmigos 			from "./routes/FavoritosAmigos.svelte";
	import Oops 					from "./routes/Oops.svelte";
	import Obrigado 				from "./routes/Obrigado.svelte";
	import Simuladores 				from "./routes/SimuladoresFinanceiros.svelte";
	import TrabalheConosco			from "./routes/TrabalheConosco.svelte";
	import GarantiasLocaticias		from "./routes/GarantiasLocaticias.svelte";
	import FichasCadastrais			from "./routes/FichasCadastrais.svelte";
	import DocumentacaoNecessaria	from "./routes/DocumentacaoNecessaria.svelte";
	import AdministracaoCondominios	from "./routes/AdministracaoCondominios.svelte";
	import SoliciteProposta			from "./routes/SoliciteProposta.svelte";

	import PromocaoLocacao			from "./routes/PromocaoLocacao.svelte";
	import PromocaoVendas			from "./routes/PromocaoVendas.svelte";
	
	// Code
	export let url 	= "";

	export let menu	= [
		{
			title: "Alugar",
			icon: '<i class="far fa-caret-down"></i>',
			subitems: [
				{
					title: 'Imóveis em oferta',
					href: `/imoveis/locacao#nt=${atria.rent}&tipo_negociacao=${atria.rent}`,
					useLink: false,
					// forceReload: true
				},
				{
					title: 'Aluguel por temporada',
					href: `/imoveis/temporada#nt=${atria.rentExtra}&tipo_negociacao=${atria.rentExtra}`,
					useLink: false,
					// forceReload: true
				},
				{
					title: 'Anuncie seu imóvel',
					href: '/anuncie'
				},
				{
					title: 'Solicite um imóvel',
					href: '/solicite'
				},
				{
					title: 'Documentação necessária',
					href: '/documentacao-necessaria'
				},
				{
					title: 'Fichas cadastrais',
					href: '/fichas-cadastrais'
				},
				{
					title: 'Garantias locatícias',
					href: '/garantias-locaticias'
				},
				{
					title: 'Favoritos',
					href: '/favoritos'
				},
			]			
		},
		{
			title: "Comprar",
			icon: '<i class="far fa-caret-down"></i>',
			subitems: [
				{
					title: 'Imóveis em oferta',
					href: `/imoveis/vendas#nt=${atria.sell}&tipo_negociacao=${atria.sell}`,
					useLink: false,
					// forceReload: true
				},
				{
					title: 'Promoção de Inverno',
					href: '/promocao/inverno'
				},
				{
					title: 'Anuncie seu imóvel',
					href: '/anuncie'
				},
				{
					title: 'Solicite um imóvel',
					href: '/solicite'
				},
				{
					title: 'Simuladores financeiros',
					href: '/simuladores-financeiros'
				},
				{
					title: 'Favoritos',
					href: '/favoritos'
				},
			]
		},
		{
			title: "Condomínios",
			icon: '<i class="far fa-caret-down"></i>',
			subitems: [
				{
					title: 'Administração de condomínios',
					href: '/administracao-condominios'
				},
				{
					title: 'Solicite uma proposta',
					href: '/solicite-proposta'
				},
			]
		},
		{
			title: 'Empresa',
			href: '/sobre'
		},
		{
			title: 'Contato',
			icon: '<i class="far fa-caret-down"></i>',
			subitems: [
				{
					title: 'Entre em contato',
					href: '/contato'
				},
				{
					title: 'Trabalhe conosco',
					href: '/trabalhe-conosco'
				},
			]
		},
		{
			title: 'Área do Cliente',
			classe: 'btn btn-primary',
			href: $linkAV,
			target: '_blank'
		}
	];

</script>

<Router url="{url}">
	<Header classe="" style="double" menu={menu} logoHeight="58px" />
	<main class="fadeIn">
		<div class="routes">
			<!-- Rotas -->
			<Route path="/"><Home /></Route>
			<Route path="/home"><Home /></Route>
			<Route path="/go-imovel/:nt/:id/:extra" let:params>
				<section class="conteudo-internas">
					<Imovel nt="{params.nt}" id="{params.id}" shareCallback={true} />
				</section>
			</Route>
			<Route path="/go-imovel/:nt/:id/:extra/:extra2" let:params>
				<section class="conteudo-internas">
					<Imovel nt="{params.nt}" id="{params.id}" shareCallback={true} />
				</section>
			</Route>
			<Route path="/imovel/:nt/:id/:extra" let:params>
				<section class="conteudo-internas">
					<Imovel nt="{params.nt}" id="{params.id}" />
				</section>
			</Route>
			<Route path="/imovel/:nt/:id/:extra/:extra2" let:params>
				<section class="conteudo-internas">
					<Imovel nt="{params.nt}" id="{params.id}" />
				</section>
			</Route>
			<Route path="/trabalhe-conosco">
				<section class="conteudo-internas">
					<TrabalheConosco />
				</section>
			</Route>
			<Route path="imoveis/vendas" let:params>
				<section class="conteudo-internas">
					<Imoveis {...params}/>
				</section>
			</Route>
			<Route path="imoveis/locacao" let:params>
				<section class="conteudo-internas">
					<Imoveis {...params}/>
				</section>
			</Route>
			<Route path="imoveis/temporada" let:params>
				<section class="conteudo-internas">
					<Imoveis {...params}/>
				</section>
			</Route>
			<Route path="imoveis" let:params>
				<section class="conteudo-internas">
					<Imoveis {...params}/>
				</section>
			</Route>
			<Route path="administracao-condominios">
				<section class="conteudo-internas">
					<AdministracaoCondominios />
				</section>
			</Route>
			<Route path="solicite-proposta">
				<section class="conteudo-internas">
					<SoliciteProposta />
				</section>
			</Route>
			<Route path="anuncie">
				<section class="conteudo-internas">
					<Anuncie />
				</section>
			</Route>
			<Route path="solicite">
				<section class="conteudo-internas">
					<SoliciteImovel />
				</section>
			</Route>
			<Route path="simuladores-financeiros">
				<section class="conteudo-internas">
					<Simuladores />
				</section>
			</Route>
			<Route path="contato">
				<section class="conteudo-internas">
					<Contato />
				</section>
			</Route>
			<Route path="sobre">
				<section class="conteudo-internas">
					<Sobre />
				</section>
			</Route>
			<Route path="privacidade">
				<section class="conteudo-internas">
					<Privacidade />
				</section>
			</Route>
			<Route path="favoritos">
				<section class="conteudo-internas">
					<Favoritos />
				</section>
			</Route>
			<Route path="favoritos-imobiliaria">
				<section class="conteudo-internas">
					<FavoritosImobiliaria />
				</section>
			</Route>
			<Route path="favoritos-amigo">
				<section class="conteudo-internas">
					<FavoritosAmigos />
				</section>
			</Route>
			<Route path="garantias-locaticias">
				<section class="conteudo-internas">
					<GarantiasLocaticias />
				</section>
			</Route>
			<Route path="documentacao-necessaria">
				<section class="conteudo-internas">
					<DocumentacaoNecessaria />
				</section>
			</Route>
			<Route path="fichas-cadastrais">
				<section class="conteudo-internas">
					<FichasCadastrais />
				</section>
			</Route>
			<Route path="oops">
				<section class="conteudo-internas">
					<Oops />
				</section>
			</Route>
			<Route path="obrigado">
				<section class="conteudo-internas">
					<Obrigado />
				</section>
			</Route>
			<Route path="bkppromocao/inverno" let:params>
				<section class="conteudo-internas">
					<PromocaoVendas {...params}/>
				</section>
			</Route>
			<Route path="bkppromocao/aluguel" let:params>
				<section class="conteudo-internas">
					<PromocaoLocacao {...params}/>
				</section>
			</Route>
		</div>
	</main>
	<Footer/>
	<Aviso />
</Router>